import { useRef } from 'preact/hooks'

import { PbPropsProvider } from '@content/helpers/src/context'
import { getPBProps } from '@content/helpers/src/utils.ts'
import { CategoryType, PBProps } from './types'
import styles from './MediaTextWithChips.module.scss'
import { getTestId } from '@content/helpers/src/utils'

import useImpressionTracker from '@content/helpers/src/hooks/useImpressionTracker'
import SectionHeader from '@commons/section-header/SectionHeader'
import ChipsCategories from '@commons/chips-categories/ChipsCategories'
import { MediaTextComponent } from '@components/media-text/MediaText'
import { useState } from 'preact/hooks'
import { IconPath } from '@nespresso-design-system/components'

type MediaAndTextWithChipsProps = {
    data: string
}

function MediaTextWithChips({ data }: MediaAndTextWithChipsProps) {
    const pbProps = getPBProps<PBProps>(data)
    const { copywriting, layout, campaign } = pbProps as PBProps
    const categories = copywriting.categories?.map((cat: CategoryType) => ({
        ...cat,
        icon: cat.icon as IconPath
    }))
    const layoutPadding = [layout.padding_top, layout.padding_bottom]
    const { background_color } = layout

    const containerRef = useRef(null)
    const [activeCategory, setActiveCategory] = useState<string>(
        categories?.[0]?.id || ''
    )

    useImpressionTracker(containerRef, campaign)

    const handleCategoryChange = (data: string) => {
        setActiveCategory(data)
    }

    const backgroundClassMap = {
        subtle_highlight: styles['background-default-highlight']
    }

    const backgroundClass =
        backgroundClassMap[background_color] ||
        (background_color ? styles[`background-${background_color}`] : '')

    return (
        <div ref={containerRef} data-testid={getTestId('mediaTextWithChips')}>
            <PbPropsProvider value={pbProps}>
                <div
                    className={`${backgroundClass} ${styles.container} ${styles[`media-text--is-position-${layout.align}`]} ${[...layoutPadding].join(' ')} ${styles[`contrast-${layout.contrast}`]}`}>
                    <SectionHeader
                        align="center"
                        alignMobile="left"
                        headline={copywriting.title}
                        description={copywriting.description}
                    />
                    <div>
                        <ChipsCategories
                            campaign={campaign}
                            categories={categories}
                            categoryCallback={handleCategoryChange}
                            activeCategory={activeCategory}
                        />
                        <MediaTextComponent
                            layout={layout}
                            layoutPadding={['p0', 'p0']}
                            campaign={campaign}
                            selectedCategory={activeCategory}
                            className={styles.mediaText}
                        />
                    </div>
                </div>
            </PbPropsProvider>
        </div>
    )
}

export default MediaTextWithChips
